import { BaseText, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { ReactNode } from 'react';
import { EBrandTextColor } from '../../../../../../libraries/typography.library';
import styles from './PromoTableItem.module.scss';

export interface ITableItemProps {
  text?: string;
  bonusValue?: any;
  children?: ReactNode;
  alignBonusValue?: 'jc-sb';
}

const TableItem = (props: ITableItemProps) => {
  return (
    <>
      <div className={`d-fl ai-c jc-c ${styles.account_bonus__item}`}>
        <div className={`${styles.container_right} d-fl ai-c ${props.alignBonusValue ? props.alignBonusValue : ''}`}>
          <div className={`${styles.bonus_label}`}>
            <BaseText value={props.text} color={EBrandTextColor.Subtitle} weight={EBaseTextWeight.W400}></BaseText>
          </div>
          <div className={`${styles.right_side}`}>
            {props.children ? (
              props.children
            ) : (
              <BaseText value={props.bonusValue} color={EBrandTextColor.Black} weight={EBaseTextWeight.W400}></BaseText>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TableItem;
